// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__NZTs4","notes":"Notes_notes__qKaBV","note":"Notes_note__3BwPF","markdown":"Notes_markdown__pQ6s9"};